import React, {FunctionComponent} from 'react';
import {Helmet} from 'react-helmet';

import {isPremise} from '../../shared/utils/premise';
import {TileButtons} from './TileButtons';
import TrialCallout from './TrialCallout';
import FavoriteList from './FavoriteList';
import RecentActivityList from './RecentActivityList';
import SchedulesList from './SchedulesList';
import GettingStarted from './GettingStarted';
import OnboardingDialogContainer from '../admin/account/components/onboardingdialog/OnboardingDialogContainer';
import CustomMessageCallout from "./CustomMessageCallout";

import './Home.scss';

type HomeComponentProps = {};

const HomeComponent: FunctionComponent<HomeComponentProps> = ({}: HomeComponentProps) => {

  return (
    <>
      <Helmet>
        <title>
          Home
        </title>
      </Helmet>
      <div className="home">
        <div className="home__content">
          <TileButtons/>
          <TrialCallout/>
          <CustomMessageCallout/>
          {
            !isPremise() && (
              <div className="home__content__lists">
                <GettingStarted/>
              </div>
            )
          }
          <div className="home__content__lists">
            <FavoriteList/>
          </div>
          <div className="home__content__lists">
            <RecentActivityList/>
            <SchedulesList/>
          </div>
        </div>
      </div>
      {!isPremise() && <OnboardingDialogContainer/>}
    </>
  );
};

export default HomeComponent;
